import * as React from "react";
import { useState } from "react";
import styled, { css } from "styled-components";
import capitalize from "lodash/capitalize";
import { useStore } from "stores/connect";
import EntityShareStore from "stores/permissions/EntityShareStore";
import { DEFAULT_PAGE_SIZES } from "hooks/usePaginationQueryParameter";
import {
  GranteeInfo,
  GranteeListItemContainer,
  GranteeListItemTitle,
  StyledGranteeIcon
} from "components/permissions/CommonStyledComponents";
import { PageSizeSelect, Pagination } from "components/common";
import { Alert } from "components/bootstrap";
const List = styled.div(
  ({ theme }) => `
  >:nth-child(even) {
    background: ${theme.colors.table.row.backgroundStriped};
  };

  >:nth-child(odd) {
    background: ${theme.colors.table.row.background};
  };
`
);
const StyledPageSizeSelect = styled(PageSizeSelect)(
  ({ theme }) => css`
    label {
      font-weight: normal;
      font-size: ${theme.fonts.size.body};
    }
  `
);
const PaginationWrapper = styled.ul`
  display: flex;
  justify-content: center;

  .pagination {
    margin: 10px 0;
  }
`;
const StyledPagination = styled(Pagination)`
  margin-top: 10px;
  margin-bottom: 0;
`;
const StyledDiv = styled.div`
  flex: 1;
`;
const getPaginatedGrantees = (selectedGrantees, pageSize, currentPage) => {
  const begin = pageSize * (currentPage - 1);
  const end = begin + pageSize;
  return selectedGrantees.slice(begin, end);
};
const ShareDetails = ({ shareState = null }) => {
  const { state: entityShareState } = useStore(EntityShareStore);
  const initialPageSize = DEFAULT_PAGE_SIZES[0];
  const [pageSize, setPageSize] = useState(initialPageSize);
  const [currentPage, setCurrentPage] = useState(1);
  if (!shareState) {
    return null;
  }
  const activeShares = entityShareState == null ? void 0 : entityShareState.activeShares;
  const selectedGrantees = entityShareState == null ? void 0 : entityShareState.selectedGrantees;
  const paginatedGrantees = getPaginatedGrantees(selectedGrantees, pageSize, currentPage);
  const totalGrantees = selectedGrantees.size;
  const totalPages = Math.ceil(totalGrantees / pageSize);
  const showPageSizeSelect = totalGrantees > initialPageSize;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("h3", null, "Share"), /* @__PURE__ */ React.createElement("p", null, "Collaborators"), showPageSizeSelect && /* @__PURE__ */ React.createElement(StyledPageSizeSelect, { onChange: (newPageSize) => setPageSize(newPageSize), pageSize }), paginatedGrantees.size > 0 ? /* @__PURE__ */ React.createElement(List, null, paginatedGrantees.map((grantee) => {
    const currentGranteeState = grantee.currentState(activeShares);
    return /* @__PURE__ */ React.createElement(GranteeListItemContainer, { key: grantee.id, $currentState: currentGranteeState }, /* @__PURE__ */ React.createElement(GranteeInfo, { title: grantee.title }, /* @__PURE__ */ React.createElement(StyledGranteeIcon, { type: grantee.type }), /* @__PURE__ */ React.createElement(GranteeListItemTitle, null, grantee.title)), /* @__PURE__ */ React.createElement(StyledDiv, null, capitalize(grantee.capabilityId)));
  }).toArray()) : /* @__PURE__ */ React.createElement(Alert, null, "This Event definition has no collaborators."), /* @__PURE__ */ React.createElement(PaginationWrapper, null, /* @__PURE__ */ React.createElement(StyledPagination, { totalPages, currentPage, onChange: setCurrentPage })));
};
export default ShareDetails;
